export const toggleAllVideos = (shouldPause) => {
  const videos = document.querySelectorAll("video");
  videos.forEach((video) => {
    if (shouldPause) {
      video.pause();
    } else {
      const rect = video.getBoundingClientRect();
      const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;
      if (isInViewport) video.play().catch(() => {});
      else video.pause();
    }
  });
};
